<template>
  <basic-container>
    <div class="bankmanageDetail">
      <div class="bankdetail_title">
        <div class="banktail_">
          <Details
            :detaildeta="detaildeta"
            :data="data"
            @updatastate="updatastate"
            @quanxian="quanxian"
            @passcheck="passcheck"
            @closeoutbut="closeoutbut"
            @changes="changes"
            @edit="edit"
          />
          <Detaillist
            :detaillist="detaillist"
            :data="data"
            @warningblock="warningblock"
          />

          <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <!-- <el-tab-pane class="activelabel" label="付款详情" name="first"
                ><Usermanage
                 
                  :data="data"
                />
              </el-tab-pane> -->

              <el-tab-pane class="activelabel" label="附件信息" name="first">
                <div class="informationxm">
                  <Accessory
                    idname="收尾管理"
                    :upload="data.closeState == 1 && permission.close_add"
                    :projectid="data.id"
                    :projectname="data.name"
                    :packagedownload="data.closeState == 3 ? true : false"
                    fatername="转贷"
                  />
                  <!-- {{permission.close_add && data.closeState == 1}} -->
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
      <div>
        <Dialog :data="data" ref="dialogpass" />
        <Dialogreason
          :passdata="passdata"
          @passcheck="passcheck"
          ref="reasondialog"
        />
      </div>
    </div>
  </basic-container>
</template>

<script>
import Usermanage from "./components/usermanage.vue";
import Accessory from "@/components/accessoriesother/accessory";
import * as api from "@/api/zd/projectconclusion";
import Dialog from "./components/dialog";
import Dialogreason from "./components/reason";
import Details from "@/components/detail/projectconclusiondetail";
import Detaillist from "@/components/detail/detaillist";
import { mapGetters } from "vuex";
export default {
  name: "bankmanageDetail",
  data() {
    return {
      activeName: "first",
      data: {},
      passblock: false,
      passdata: {
        id: "",
        advise: "",
        pass: false,
      },
      auditstateName: "",
      butshengheloading: false,
      but_shenghe: false,
      statetitle: "",
      butstatetitle: "",
      bankStateName: "",
      examine: true,
      wf_state: [],
      audit_state: [],
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dialogVisible: false,

      option0: {
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "原因描述",
            prop: "advise",
            type: "textarea",
            minRows: 4,
            maxlength: 200,
            span: 24,
            rules: [
              {
                required: true,
                message: "请输入原因",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      detaildeta: {
        edit: "false",
        add: "permission.close_add",
        audit: "permission.close_audit",
        title: "data.name ",
      },
      detaillist: {
        column: [
          {
            label: "项目编号",
            prop: "number",
          },
          {
            label: "客户名称",
            prop: "custName",
          },
          {
            label: "申请银行",
            prop: "bankName",
          },
          {
            label: "申请转贷金额",
            prop: "quota",
            formatter: () => {
              return this.getMoney(this.data.quota) + " 元";
            },
          },
          {
            label: "使用费率",
            prop: "loanRate ",
            formatter: () => {
              return this.data.loanRate * 100 + "%";
            },
          },
          {
            label: "客户经理",
            prop: "managerName ",
          },
        ],
        showcolumn: [
          {
            label: "收尾状态",
            prop: "closeState",
            show: "pageData.closeState>=1",
            auditlog: true,
            state: 0,
            // state ：0  前面是否加上小圆点
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=close_state",
          },
        ],
        firstsblock: {
          formatter: () => {
            return this.data.wfStatus == 2 && this.data.auditState >= "1"
              ? 20
              : 19;
          },
        },
        sentersblock: {
          formatter: () => {
            return this.data.wfStatus == 2 && this.data.auditState >= "1"
              ? 4
              : 5;
          },
        },

        firstrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
        secondrow: {
          formatter: () => {
            return {
              width: "40%",
            };
          },
        },
        thirdrow: {
          formatter: () => {
            return {
              width: "30%",
            };
          },
        },
      },
    };
  },
  components: {
    Usermanage,
    Dialogreason,
    Accessory,
    Dialog,
    Details,
    Detaillist,
  },
  watch: {
    $route: {
      handler() {
        let id = this.$route.params.id;
        this.onLoad(id);
      },
      deep: true,
    },
  },
  created() {
    this.onLoad(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["permission"]),
    firstsblock() {
      return this.data.closeState == 1 ? 6 : 7;
    },
    sentersblock() {
      return this.data.closeState == 1 ? 8 : 10;
    },
    lastsblock() {
      return this.data.closeState == 1 ? 7 : 7;
    },
    leftsblock() {
      return this.data.wfStatus == 2 && this.data.auditState >= "1" ? 21 : 19;
    },
    rightsblock() {
      return this.data.closeState == 1 ? 3 : 0;
    },
  },
  methods: {
    getwf_state() {
      api.wf_state().then((res) => {
        this.wf_state = res.data.data;
      });
    },
    getaudit() {
      api.audit_state().then((res) => {
        this.audit_state = res.data.data;
      });
    },
    bankstate(data) {
      api.bankstate().then((res) => {
        let vals = res.data.data.findIndex((val) => val.dictKey == data);
        this.bankStateName = res.data.data[vals].dictValue;
      });
    },

    // 通过
    quanxian(id, type) {
      // this.passblock = true;
      // this.passtype=type
      this.passdata.id = id;
      this.$refs.reasondialog.showblock(type);
    },
    //确定通过或退回
    passcheck(data, type) {
      
      if (type == "change") {
        // 变更
        api.bankchange({ id: data.id, reason: data.advise }).then((res) => {
          this.$router.push({
            path: `/zd/paymentmanage/edit/${res.data.data}`,
          });
        });
      } else {
        api.closeAuditaudit(data).then((res) => {
          this.onLoad(this.$route.params.id);
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        });
      }
    },
    onLoad(id) {
     
      api
        .projectCloseinfo({ id: id })
        .then(res => {
         
          // this.getauditstate(res.data.data);
          // this.bankstate(res.data.data.bankState);
          this.data = res.data.data;
          // this.data.wfStatus = res.data.data.wfStatus.toString();
          this.data.auditLog = JSON.parse(res.data.data.auditLog);
          // this.data.contractTerms = res.data.data.contractTerms.slice(0, 11);
        })
        .catch(res => {
           
        });
    },
    warningblock() {
      this.$refs.dialogpass.showblock();

      // this.dialogVisible = true;
    },
    closeoutbut() {
      this.$confirm("是否确定提交收尾?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.closeSubmitAudit({ id: this.data.id }).then((res) => {
          this.onLoad(this.$route.params.id);
        });
      });
    },

    updatastate(type) {
      //examine ture  审批  false 审核
      let that = this;
      api
        .submitWorkflowCheck({ id: this.data.id })
        .then(res => {
           
          if (type) {
            this.$confirm("是否确定提交审批?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                api
                  .submitWorkflow({ id: this.data.id })
                  .then((res) => {
                    this.$alert(
                      "数据已同步至OA系统，请您前往OA工作流中查看",
                      "信息提示",
                      {
                        confirmButtonText: "确定",
                        callback: (action) => {
                          this.$message({
                            type: "info",
                            message: "请您前往OA工作流中查看",
                          });
                        },
                      }
                    );
                    this.onLoad(this.$route.params.id);
                  })
                  .catch(res => {
                     
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
          } else {
            this.$confirm("是否确定提交审核?", "操作确认", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                this.butshengheloading = true;
                api
                  .submitaudit({ id: this.data.id })
                  .then(res => {
                     
                    this.$message({
                      type: "success",
                      message: res.data.msg,
                    });
                    this.onLoad(this.$route.params.id);
                  })
                  .catch(res => {
                     
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除",
                });
              });
          }
        })
        .catch(res => {
         
          const confirmText = ["必填内容填写不完全", "请检查数据内容是否完整"];
          const newDatas = [];
          const h = that.$createElement;
          for (const i in confirmText) {
            newDatas.push(h("p", null, confirmText[i]));
          }
          that
            .$confirm("警告提示", {
              title: "提示",
              message: h("div", null, newDatas),
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {})
            .catch(() => {
              that.$message({
                type: "info",
                message: "已取消",
              });
            });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.bankmanageDetail {
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    z-index: 20;
    flex-direction: row;

    .history_content {
      width: 110px;
      cursor: pointer;
      height: 45px;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      text-align: right;
      padding-right: 15px;
      border-radius: 5px 0 0 5px;
    }
  }
  .banktail_ {
    width: 1000px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 13px;
      // margin-bottom: 15px;
      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        .list_top {
          flex: 1;
        }
        .topone {
          flex: 1.5;
        }
        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }
}

.bankstate_0:before {
  background: #fec03d;
}
.bankstate_1:before {
  background: #51d351;
}
.bankstate_2:before {
  background: #ff7a8c;
}

.auditState_0:before {
  background: #fec03d;
}
.auditState_1:before {
  background: #409eff;
}
.auditState_2:before {
  background: #51d351;
}

.flagBook_0:before {
  background: #fec03d;
}
.flagBook_1:before {
  background: #fec03d;
}
.flagBook_2:before {
  background: #fec03d;
}
.flagBook_3:before {
  background: #90cb31;
}
.warningblock {
  cursor: pointer;
  color: rgb(197, 192, 192);
}
.box_card {
  width: 100%;
  box-shadow: 1px 1px 5px #ddd;
  margin: 20px 0;
  .demo-basic {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 13px;
  }
}
.autilog {
  display: flex;
  flex-direction: column;
}
.warningtext {
  color: rgb(197, 192, 192);
  font-size: 12px;
}

.box_cards {
  height: 450px;
  overflow-y: auto;
}
.passblocksblock {
  // margin-top: 25px;
  text-align: right;
}
/deep/.el-tabs__header {
  margin: 0px;
}
/deep/.el-form-item {
  margin-bottom: 0px;
}
/deep/.el-form-item__label {
  color: #999999;
}
</style>
<style>
.banktail_ .el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.bankmanageDetail .el-tabs__item.is-active {
  background: none;
}
</style>
